// Add your Google OAuth 2.0 Client ID
// Get credentials from: https://console.cloud.google.com/

export const GOOGLE_CONFIG = {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '156581459763-ip9efim4viis34v6qfqu38c1a8a45q6p.apps.googleusercontent.com',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'],
  scope: 'https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/gmail.settings.basic https://mail.google.com/'
};
